import * as React from 'react';
import { useState, cloneElement } from 'react';

/** Material UI Packages. */
import { Button } from '@mui/material';

export default function ThemeButton({ role, text, icon, width, onClick, sx, iconStyle, disabled = false }) {
    return (
        <Button
            variant="contained"
            onClick={onClick}
            disabled={disabled}
            role={role}
            sx={{
                color: 'white',
                bgcolor: '00647e',
                borderRadius: '3px',
                width: { width },
                height: '27px',
                ...sx,
            }}
        >
            {icon && cloneElement(icon, { sx: { fontSize: '13px', ...iconStyle } })}
            {text}
        </Button>
    );
}

export function DialogButton({ text, icon, onClick, sx, additional }) {
    return (
        <Button
            onClick={onClick}
            sx={{
                color: '#00647e',
                bgcolor: 'white',
                height: '30px',
                borderRadius: '3px',
                width: '68px',
                ':hover': { bgcolor: 'rgb(0,100,126)', color: 'white' },
                ...sx,
            }}
            {...additional}
        >
            {icon && cloneElement(icon, { sx: { fontSize: '13px' } })}

            {text}
        </Button>
    );
}
